import React, { Fragment, useEffect } from 'react';
import { Typography, Card, Row, Col, Avatar, Checkbox, Space } from 'antd';
import { getPublicSiteImageSrc } from 'Client/common/utils/AppUtils';
import { INTERESTED_APIS } from 'Client/common/constants/AppConstants';


const CardsFour = ({handleCheckboxSelection, interestedApis}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="ant-result-title">
        <Fragment>
          <Typography.Title level={2} className="cards-heading">
            <Space>
              <Avatar 
                style={{ backgroundColor: '#074079', size: 'large' }} 
                size={{ xs: 32, sm: 32, md: 36, lg: 36, xl: 36, xxl: 36}}
                aria-label="Step 4"
              >
                4
              </Avatar> 
              <span className="avatar-text" id="api-selection-heading">Which APIs are you interested in ?</span>
            </Space>
          </Typography.Title>
        </Fragment>
      </div>
      <Checkbox.Group 
        name="interestedApis" 
        value={interestedApis}
        onChange={handleCheckboxSelection}
        role="group"
        aria-labelledby="api-selection-heading"
      >
        <Row gutter={[{xs: 32, sm: 32, md: 64, lg: 16, xl: 16}, 16]} justify="space-around">
          {INTERESTED_APIS.map((apiConnection, index) => (
            <Col xs={12} sm={12} md={6} key={index}>
              <Card
                className="checkbox-card"
                bodyStyle={{
                  height: "inherit"
                }}
              >
                 <Row style={{height:"inherit"}} justify="space-around">
                  <Col sm={{span: 12}} md={{offset: 2, span: 12}}>
                    <img
                      src={
                        getPublicSiteImageSrc(apiConnection.toLowerCase().replaceAll(' ', '-') + ".svg")
                      }
                      alt={`${apiConnection} API icon`}
                      className="qna_image"
                      aria-hidden="true"
                    />
                  </Col>
                  <Col span={24}>
                    <Checkbox 
                      value={apiConnection}
                      aria-describedby={`api-desc-${index}`}
                      role="checkbox"
                    >
                      <span className='qna-value' id={`api-desc-${index}`}>{apiConnection}</span>
                    </Checkbox>
                  </Col>
                 </Row>
              </Card>
            </Col>
          ))}
        </Row>
      </Checkbox.Group>
    </div>
  );
};

export default CardsFour;
